{
  "local": {
    "msalClientId": "e02003fa-88f3-4801-b6c4-54d45fb5cab1",
    "msalTenantId": "a365uat",
    "msalb2c": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com/b2c_1a_ansysid_signup_signin",
    "msalAuthDomain": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com",
    "msalPortalScope": "https://a365uat.synopsys.com/AnsysID/Authentication",
    "autoAccountID": "2a566ece-938d-4658-bae5-ffa387ac0547",
    "apiURL": "https://test-conceptev.awsansys3np.onscale.com/api",
    "appURL": "http://localhost:4200"
  },
  "devolopment": {
    "msalClientId": "e02003fa-88f3-4801-b6c4-54d45fb5cab1",
    "msalTenantId": "a365uat",
    "msalb2c": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com/b2c_1a_ansysid_signup_signin",
    "msalAuthDomain": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com",
    "msalPortalScope": "https://a365uat.synopsys.com/AnsysID/Authentication",
    "autoAccountID": "806ab401-cd25-4480-9a10-558a4a78dc75",
    "apiURL": "https://dev-conceptev.awsansys3np.onscale.com/api",
    "appURL": "https://dev-conceptev.awsansys3np.onscale.com"
  },
  "testing": {
    "msalClientId": "e02003fa-88f3-4801-b6c4-54d45fb5cab1",
    "msalTenantId": "a365uat",
        "msalb2c": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com/b2c_1a_ansysid_signup_signin",
    "msalAuthDomain": "https://a365uat.synopsys.com/a365uat.onmicrosoft.com",
    "msalPortalScope": "https://a365uat.synopsys.com/AnsysID/Authentication",
    "autoAccountID": "2a566ece-938d-4658-bae5-ffa387ac0547",
    "apiURL": "https://test-conceptev.awsansys3np.onscale.com/api",
    "appURL": "https://test-conceptev.awsansys3np.onscale.com"
  },
  "production": {
    "msalClientId": "d8434bbf-552c-4672-ac1b-1cadbef28144",
    "msalTenantId": "ansysaccount",
    "autoAccountID": "e8cfbf84-058c-43cf-9eb4-9917b1ab2e9f",
    "apiURL": "https://conceptev.ansys.com/api",
    "appURL": "https://conceptev.ansys.com"
  }
}
